export default {
      id: "shape-top-2000-usage",
      viewBox: "0 0 2000 400.15",
      url: "../../../plugins/creasit-builder/assets/dist/images/" + "sprite.svg#shape-top-2000-usage",
      toString: function () {
        return this.url;
      }
    }